// ***********对输入信息进行处理（过滤，转换格式,分类），备份数据，抛出新消息

import Types from 'src/config/info-types.js';  //配置文件

const infoList = [];  // 未读信息池
const funcList = [];  //函数回调列表

function filterInfo(arr){  //过滤重复信息
    return arr.filter(info=>{
        return infoList.every(item=>{
            return item.info_id !== info.info_id;
        })
    })
}

function classify(arr){  //信息分类 返回细分对象
    let all = {};
    arr.forEach(info=>{
        for(let key in Types){
            let arr = Types[key];
            let index = arr.indexOf(info.type);
            if(index != -1){
                all[key] || (all[key] = []);
                all[key].push(info);
            }
        }
    });
    return all;
}

function adjustTime(arr){  //调整所有信息的created_at时间
    arr.forEach(info => {
        let time_str = info.created_at;
        info.time = getTime(time_str);
        info.created_at = getCreated(time_str);
    });
    return arr;
}

// 返回毫秒数
function getTime(str){
    if(isNaN(str)){
        return new Date(str).getTime();
    }else{
        return parseInt(str);
    }
}

//返回 时间格式
function getCreated(str){
    if(isNaN(str)){
        return str;
    }else{
        let date = new Date(parseInt(str));
        return date.toLocaleDateString().replace(/\//g, "-") + " " + date.toTimeString().substr(0, 8);
    }
}

// 新消息抛出
function send(obj){
    for(let fn of funcList){
        fn.call(this,obj);
    }
}
// *************************************************************************************


// 获取特定type消息数据，执行函数
const get = (key,fun) =>{
    let type_info = Types[key];
    let result = infoList.filter(info=>{
        return type_info.indexOf(info.type) !== -1;
    });
    fun(result);
}

//添加监听新消息的回调
const onMessage = callback=>{
    funcList.push(callback);
}

// 缓存池过滤
const addInfo = params =>{
    let arr;
    if(params instanceof Array){
        arr = params;
    }else if(typeof params === 'string'){
        arr = [JSON.parse(params)];
        // arr = filterInfo();
    }

    arr = filterInfo(arr); //过滤重复
    arr = adjustTime(arr); //调整字段
    arr.forEach(info=>{ //存进 信息池
        infoList.push(info); 
    })
    // console.log(`缓存列表`)
    // console.log(infoList)
    send(classify(arr));  //发送消息
}

// 清除缓存池信息
const remove = id=>{
    let index = -1;
    infoList.some((item,i)=>{
        return item.info_id == id && (index=i);
    });
    if(index != -1){
        infoList.splice(index,1);
    }
}

// 退出后 缓存池应该清空
const clear = ()=>{
    infoList.splice(0,infoList.length);
}
 
export default {
    addInfo:addInfo,   //过滤处理信息
    get:get,           //拿特定type  消息缓存
    remove:remove,     //移除缓存池信息 
    onMessage:onMessage,    //添加监听发送信息的回调
    clear:clear,        //清空缓存池
}


// WEBPACK FOOTER //
// ./src/control/info/cache.js